import PropTypes from 'prop-types'
import { Button, Text } from '@chakra-ui/react'
import React, { memo } from 'react'
import { colors } from '../../../../utils/theme/styles'

export const FillBalanceCell = ({ onClick }) => {
  return (
    <Button
      borderRadius="5px"
      border="transparent"
      h="24px"
      w="28px"
      color="#000000"
      position="unset"
      onClick={onClick}
      bgColor={colors.gray[100]}
    >
      =
    </Button>
  )
}

FillBalanceCell.propTypes = {
  onClick: PropTypes.func,
  clickValue: PropTypes.object,
}

const ClickeableCell = ({ value, onClick }) => {
  return (
    value && (
      <Text textAlign="end" variant="bodyHyperLink" onClick={onClick}>
        {value}
      </Text>
    )
  )
}

ClickeableCell.propTypes = {
  clickValue: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
}

export default memo(ClickeableCell)
